require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-from-burning-forests-in-brazil-to-the-trillion-tree.json") })
        }
      }, "path---en-us-update-from-burning-forests-in-brazil-to-the-trillion-tree");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-from-burning-forests-in-brazil-to-the-trillion-tree!./.cache/json/en-us-update-from-burning-forests-in-brazil-to-the-trillion-tree.json
// module id = 668
// module chunks = 231608221292675